/* global attachEvent */

// *******************************************************************************
// 1.0 - Open dropdown
// *******************************************************************************

const dropdownElement = document.querySelectorAll('.dropdown');
const dropdownPlaceholderElement = document.querySelectorAll('.dropdown__placeholder');

Array.prototype.forEach.call(dropdownPlaceholderElement, (el) => {
  el.addEventListener('click', () => {
    const dropdownParent = el.closest('.dropdown');

    Array.prototype.forEach.call(dropdownElement, (elem) => {
      if (elem !== dropdownParent) {
        elem.classList.remove('is-open');
      }
    });

    dropdownParent.classList.toggle('is-open');
  });
});

// *******************************************************************************
// 2.0 - Click on dropdown option
// *******************************************************************************

const dropdownOptionElement = document.querySelectorAll('.dropdown__list-option');
const getHash = () => window.location.hash.replace(/^#/, '');

Array.prototype.forEach.call(dropdownOptionElement, (el) => {
  el.addEventListener('click', () => {
    const dropdownParent = el.closest('.dropdown');

    // Close the dropdown
    // ev.target.closest('.dropdown.is-open').classList.remove('is-open');
    dropdownParent.classList.remove('is-open');
  });
});

// *******************************************************************************
// 3.0 - Open a specific dropdown based on has in url
// *******************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const locationHash = getHash();

  if (locationHash) {
    const selectedElem = document.querySelectorAll(`#${locationHash}`);

    // Loop throught elements to avoid errors if there is no element to be found
    selectedElem.forEach((el) => {
      // Set active selection
      el.setAttribute('checked', 'true');

      // Change text
      const dropdownParent = el.closest('.dropdown');
      const optionLabel = el.parentElement.querySelector('.dropdown__list-option');
      const dropdownPlaceholder = dropdownParent.querySelectorAll('.dropdown__placeholder');
      const dropdownOptionText = optionLabel.innerHTML;
      dropdownPlaceholder[0].innerHTML = dropdownOptionText;
    });
  }
});

document.addEventListener('click', (evt) => {
  const dropdownElemOpened = document.querySelector('.dropdown.is-open');
  let targetElement = evt.target; // clicked element

  do {
    if (targetElement === dropdownElemOpened) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  Array.prototype.forEach.call(dropdownElement, (el) => {
    const dropdownParent = el.closest('.dropdown');
    dropdownParent.classList.remove('is-open');
  });
});

// *******************************************************************************
// 4.0 - Close dropdown for mobile
// *******************************************************************************

attachEvent('.dropdown__close', 'click', (ev) => {
  const dropdownParent = ev.target.closest('.dropdown');
  dropdownParent.classList.remove('is-open');
});
